
import SwiperWrapper from './modules/SwiperWrapper'
import NavBar from './modules/NavBar'
import Action from './modules/Action'
import CountableContent from './modules/CountableContent'
import ConditionalTarget from './modules/ConditionalTarget'
import ValidatableForm from "./modules/ValidatableForm"
import Rotator from "./modules/Rotator";

window.APP_MODULES = {
    NavBar,
    SwiperWrapper,
    Action,
	CountableContent,
	ConditionalTarget,
	ValidatableForm,
	Rotator
}
